export const FILE_TYPE_ENUM = {
  CSV: 0,
  XLS: 1,
  XLSX: 2
};

export const EXPORT_FILE_EXTENSION = {
  CSV: "csv",
  XLSX: "xlsx"
};
